/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useCallback, useState, memo, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import styles from './chatBot.module.scss';
import { Messages } from './components/Messages';
import { SuggestedQuestions } from './components/SuggestedQuestions';
import { Input } from './components/Input';
import { PAMMState } from '../redux/reducers/rootReducer';
import { UpdateOpen } from '../redux/reducers/chatBotReducer';
import { Header } from './components/Header';
import aiAssistantIcon from '../icons/ai-assistant.svg';

export const ChatBot = memo(() => {
  const dispatch = useDispatch();
  const { Open } = useSelector((state: PAMMState) => state.chatBotReducer);
  const scrollRef = useRef<OverlayScrollbarsComponent | null>(null);

  const onKeyPressEscape = useCallback((e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      dispatch(UpdateOpen(false));
    }
  }, []);

  useEffect(() => {
    window.addEventListener('keydown', onKeyPressEscape);
    return () => {
      window.removeEventListener('keydown', onKeyPressEscape);
    };
  }, []);

  const onOpen = useCallback(() => {
    dispatch(UpdateOpen(true));
  }, [dispatch]);

  const scrollToBottom = () => {
    if (scrollRef.current) {
      const instance = scrollRef.current.osInstance();
      if (instance) {
        instance.scroll({ y: '100%' });
      }
    }
  };

  useEffect(() => {
    if (Open) {
      scrollToBottom();
    }
  }, [Open, scrollToBottom]);

  return (
    <>
      <img src={aiAssistantIcon} alt="Assistant" onClick={onOpen} style={{ cursor: 'pointer' }} />

      {Open && (
        <div
          className={styles['wrapperOpen']}
          style={{
            position: 'fixed',
            zIndex: 2147483647,
            bottom: '52px',
            right: '83px',
            width: '660px',
            minHeight: '560px'
          }}
        >
          <Header />
          <OverlayScrollbarsComponent
            ref={scrollRef}
            style={{ height: '434px', width: '100%', minHeight: '188px' }}
            options={{
              scrollbars: {
                autoHide: 'leave'
              }
            }}
          >
            <Messages />
          </OverlayScrollbarsComponent>
          <SuggestedQuestions />
          <Input />
        </div>
      )}
    </>
  );
});
